import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { environment } from 'environments/environment';

@Component({
  selector: 'app-external',
  templateUrl: './external.component.html',
  styleUrls: ['./external.component.scss']
})
export class ExternalComponent implements OnInit {

  constructor(private activatedRoute: ActivatedRoute) { }

  ngOnInit(): void {
    const url: string = this.activatedRoute.snapshot.queryParams.url;
    const lowercaseUrl = url.toLowerCase();
    if(lowercaseUrl.startsWith('https://prephub.webtest.ng') || lowercaseUrl.startsWith('https://pay.tranzgate.com.ng') || !environment.production){
      //we don't want this page to be used for fake redirect links so we limit where it can redirect to
      window.location.href = url;
    }
  }

}
